import { render, staticRenderFns } from "./PaginationLinksLimit.vue?vue&type=template&id=275bdeb0&"
import script from "./PaginationLinksLimit.vue?vue&type=script&lang=js&"
export * from "./PaginationLinksLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports